<template>
    <v-container class="d-flex justify-center align-center fill-height"
        style="background-color: #F5F5F5; max-width: 100%;">
        <v-card class="pa-6" elevation="2" max-width="400">
            <v-window v-model="page">
                <!-- lấy otp -->
                <v-window-item :value="1">
                    <v-card-title class="text-center">
                        <v-icon size="40" color="black">mdi-lock</v-icon>
                    </v-card-title>

                    <p class="text-center text-h5 font-weight-bold">Forgot Password?</p>
                    <v-card-text class="text-center">Please enter your email to recover password</v-card-text>

                    <v-form ref="form">
                        <v-text-field v-model="email" label="Enter email address" variant="outlined"
                            density="comfortable" prepend-inner-icon="mdi-email-outline" required :error="emailError"
                            :error-messages="emailErrorMessage" @blur="validateEmail"></v-text-field>

                        <v-otp-input v-if="showOtpField" v-model="otp" :loading="isVerifying" length="6"
                            variant="underlined"></v-otp-input>

                        <!-- <v-btn block color="primary" class="mt-3" @click="sendOtp" prepend-icon="mdi-send"
                            :disabled="emailError || email === '' || isLoading">
                            {{ isLoading ? 'Sending...' : 'Send request' }}
                        </v-btn> -->
                        <v-btn v-if="!showOtpField" block color="primary" class="mt-3" @click="sendOtp"
                            prepend-icon="mdi-send" :disabled="emailError || email === '' || isLoading">
                            {{ isLoading ? 'Sending...' : 'Send request' }}
                        </v-btn>

                        <v-btn v-if="showOtpField" block color="success" class="mt-3" @click="verifyOtp"
                            prepend-icon="mdi-check" :disabled="otp.length !== 6 || isVerifying">
                            {{ isVerifying ? 'Verifying...' : 'OTP Confirmation' }}
                        </v-btn>

                        <v-btn block class="mt-3" variant="plain" @click="goBack">
                            <v-icon left>mdi-arrow-left</v-icon> Back to login
                        </v-btn>
                    </v-form>
                </v-window-item>

                <!-- update password -->
                <v-window-item :value="2">
                    <v-card-title class="text-center">
                        <v-icon size="40" color="black">mdi-lock</v-icon>
                    </v-card-title>

                    <p class="text-center text-h5 font-weight-bold">
                        Reset Password
                    </p>

                    <v-card-text class="text-center">
                        Please enter your new password below
                    </v-card-text>

                    <v-form ref="form" @submit.prevent="resetPassword">
                        <!-- Mật khẩu mới -->
                        <v-text-field v-model="password" label="New Password" variant="outlined" density="comfortable"
                            prepend-inner-icon="mdi-lock-outline" :type="showPassword ? 'text' : 'password'"
                            :append-inner-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                            @click:append-inner="showPassword = !showPassword"
                            :rules="[rules.required, rules.minLength, rules.hasUpperLower, rules.hasNumberSpecial]">
                        </v-text-field>

                        <!-- Xác nhận mật khẩu -->
                        <v-text-field class="mt-1" v-model="confirmPassword" label="Confirm New Password"
                            variant="outlined" density="comfortable" prepend-inner-icon="mdi-lock-outline"
                            :type="showConfirmPassword ? 'text' : 'password'"
                            :append-inner-icon="showConfirmPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                            @click:append-inner="showConfirmPassword = !showConfirmPassword"
                            :rules="[rules.required, rules.passwordMatch]">
                        </v-text-field>

                        <!-- Yêu cầu mật khẩu -->
                        <v-list density="compact" class="password-requirements">
                            <v-list-item class="mt-n2 pl-1">
                                <v-icon color="green" v-if="password.length >= 8">mdi-check</v-icon>
                                <v-icon color="red" v-else>mdi-close</v-icon>
                                At least 8 characters
                            </v-list-item>
                            <v-list-item class="mt-n2 pl-1">
                                <v-icon color="green"
                                    v-if="/[a-z]/.test(password) && /[A-Z]/.test(password)">mdi-check</v-icon>
                                <v-icon color="red" v-else>mdi-close</v-icon>
                                Include uppercase & lowercase letters
                            </v-list-item>
                            <v-list-item class="mt-n2 pl-1">
                                <v-icon color="green"
                                    v-if="/\d/.test(password) && /\W/.test(password)">mdi-check</v-icon>
                                <v-icon color="red" v-else>mdi-close</v-icon>
                                Include numbers & special characters
                            </v-list-item>
                        </v-list>

                        <!-- Nút Reset Password -->
                        <v-btn block color="primary" class="mt-3" type="submit" :disabled="!isPasswordValid">
                            Reset Password
                        </v-btn>

                        <!-- Nút quay lại -->
                        <v-btn block class="mt-3" variant="plain" @click="goBack">
                            <v-icon left>mdi-arrow-left</v-icon> Back to login
                        </v-btn>
                    </v-form>
                </v-window-item>
            </v-window>

        </v-card>
    </v-container>
</template>

<script>
import axios from "../utils/axios";

export default {
    name: "QuenMatKhauComponent",
    data() {
        return {
            page: 1,
            email: "",
            otp: "",
            showOtpField: false,
            emailError: false,
            emailErrorMessage: "",
            isLoading: false,
            isVerifying: false,

            // password
            password: "",
            confirmPassword: "",
            showPassword: false,
            showConfirmPassword: false,
            rules: {
                required: (v) => !!v || "This field is required",
                minLength: (v) => (v.length >= 8) || "At least 8 characters",
                hasUpperLower: (v) => (/[a-z]/.test(v) && /[A-Z]/.test(v)) || "Must include uppercase & lowercase letters",
                hasNumberSpecial: (v) => (/\d/.test(v) && /\W/.test(v)) || "Must include numbers & special characters",
                passwordMatch: (v) => (v === this.password) || "Passwords do not match",
            }
        };
    },
    computed: {
        isPasswordValid() {
            return (
                this.password.length >= 8 &&
                /[a-z]/.test(this.password) &&
                /[A-Z]/.test(this.password) &&
                /\d/.test(this.password) &&
                /\W/.test(this.password) &&
                this.password === this.confirmPassword
            );
        }
    },
    methods: {
        validateEmail() {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!this.email.match(emailPattern)) {
                this.emailError = true;
                this.emailErrorMessage = "Invalid email!";
            } else {
                this.emailError = false;
                this.emailErrorMessage = "";
            }
        },
        async resetPassword() {
            if (this.password !== this.confirmPassword) {
                alert("Passwords do not match!");
                return;
            }

            try {
                const response = await axios.post("https://api.udf.com.vn/user/reset-password", {
                    Password: this.password,
                    Email: this.email,
                    OTP: this.otp
                });
                console.log(response.data);
                alert("Password reset successful!");
                this.$router.push("/login");
            } catch (error) {
                console.error("Reset password failed:", error);
                alert("Something went wrong. Please try again.");
            }
        },
        async sendOtp() {
            this.validateEmail();
            if (this.emailError) return;

            this.isLoading = true;
            this.otp = ""; // Reset OTP khi gửi lại yêu cầu

            try {
                const response = await axios.post("https://api.udf.com.vn/user/otp", { Email: this.email });

                console.log("Response từ API:", response.data);
                if (response.data.message === "ok") {
                    this.showOtpField = true;
                    alert("OTP đã được gửi đến email của bạn!");
                } else {
                    alert("Lỗi không xác định khi gửi OTP.");
                }
            } catch (error) {
                if (error.response) {
                    console.error("Lỗi từ API:", error.response.data);
                    alert(`Lỗi: ${error.response.data.detail || "Không rõ nguyên nhân"}`);
                } else {
                    console.error("Lỗi không có phản hồi từ server:", error);
                    alert("Lỗi kết nối đến server, vui lòng thử lại.");
                }
            } finally {
                this.isLoading = false;
            }
        },

        async verifyOtp() {
            if (this.otp.length !== 6) {
                alert("Mã OTP phải có 6 chữ số!");
                return;
            }

            this.isVerifying = true;
            try {
                const response = await axios.post("https://api.udf.com.vn/auth/user/CheckOTP", {
                    Email: this.email,
                    OTP: this.otp
                });

                if (response.data[0].Status == "ok") {
                    alert("OTP hợp lệ! Đang chuyển đến trang đổi mật khẩu.");
                    // window.location.href = `/reset-password?email=${this.email}`;
                    this.page = 2
                } else {
                    alert("Mã OTP không chính xác, vui lòng thử lại.");
                }
            } catch (error) {
                console.error("Lỗi xác minh OTP:", error);
                alert("Có lỗi xảy ra, vui lòng thử lại.");
            } finally {
                this.isVerifying = false;
            }
        },

        goBack() {
            window.location.href = "/login";
        }
    }
};
</script>
